import { useTranslation } from 'react-i18next'
import Button, { ButtonSize, ButtonVariant } from '@components/DesignSystem/Button'
import { Spinner } from '@components/Spinner'

type ScheduleButtonProps = {
  className?: string
  onClick: () => void
  status: string
}

const ScheduleButton = ({ className, onClick, status }: ScheduleButtonProps) => {
  const { t } = useTranslation('editor')

  return (
    <Button
      size={ButtonSize.block}
      variant={ButtonVariant.primary}
      onClick={onClick}
      className={className}
    >
      {status === 'pending' ? <Spinner width={18} /> : t('aside.schedule')}
    </Button>
  )
}

export default ScheduleButton
